import { parseBookingRequirements } from '../components/VenueDashboard/utils/bookingAddOns';

export const parseHeadcount = (value) => {
  const parsed = Number.parseInt(value, 10);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : null;
};

/** One people-count field. Legacy aliases are read-only fallbacks for old rows. */
export const bookingHeadcount = (booking, req = null) => {
  const parsedReq = req || parseBookingRequirements(booking);
  return (
    parseHeadcount(booking?.headcount) ??
    parseHeadcount(booking?.guest_count) ??
    parseHeadcount(booking?.expected_attendees) ??
    parseHeadcount(parsedReq?.headcount) ??
    parseHeadcount(parsedReq?.table_count)
  );
};

/** Leftover seats this booking may use after other overlapping bookings. */
export const maxHeadcountAfterOthers = (capacityTotal, othersSeatsTaken = 0) => {
  const cap = Number(capacityTotal);
  const others = Number(othersSeatsTaken);
  if (!Number.isFinite(cap) || cap <= 0) return 0;
  const taken = Number.isFinite(others) && others > 0 ? others : 0;
  return Math.max(0, cap - taken);
};

const timeToMinutes = (time) => {
  const match = String(time || '').match(/^(\d{1,2}):(\d{2})/);
  if (!match) return null;
  return Number(match[1]) * 60 + Number(match[2]);
};

export const bookingWindowsOverlap = (a, b) => {
  const spaceA = String(a?.space_id || a?.spaceId || '');
  const spaceB = String(b?.space_id || b?.spaceId || '');
  if (spaceA && spaceB && spaceA !== spaceB) return false;
  const dateA = String(a?.booking_date || '').split('T')[0];
  const dateB = String(b?.booking_date || '').split('T')[0];
  if (!dateA || dateA !== dateB) return false;
  const aStart = timeToMinutes(a?.start_time);
  const aEnd = timeToMinutes(a?.end_time);
  const bStart = timeToMinutes(b?.start_time);
  const bEnd = timeToMinutes(b?.end_time);
  if ([aStart, aEnd, bStart, bEnd].some((value) => value == null)) return false;
  return aStart < bEnd && aEnd > bStart;
};
